<template>
  <div>
    <div v-if="$page.props.flash.success && show" class="mb-8 flex items-center justify-between bg-green-500 rounded">
      <div class="alert alert-success alert-dismissible fade show" role="alert">
        {{ $page.props.flash.success }}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="show = false"></button>
      </div>
    </div>
    <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show" class="mb-8 flex items-center justify-between bg-red-400 rounded">
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ $page.props.flash.success }}
        <div v-if="$page.props.flash.error">{{ $page.props.flash.error }}</div>
        <div v-else>
          <ul style="margin-bottom: 0">
            <li class="list-disc" v-for="(item, index) in $page.props.errors" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"  @click="show = false"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
